import { render, staticRenderFns } from "./choiceRes.vue?vue&type=template&id=2ca070b3&"
import script from "./choiceRes.vue?vue&type=script&lang=js&"
export * from "./choiceRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports